import React, { useContext, useEffect } from "react";

import { Container, Grid, Grow } from "@material-ui/core";
import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import Fieldset from "../../../../components/basics/Fieldset";
import Select from "../../../../components/basics/SelectErp";
import { EmissaoContext } from "../contexts/EmissaoContext";
import useEmissaoController from "../controllers/EmissaoController";
import { Header, Body } from "../styles/Emissao";
import { Margin } from "../../../../theme/styles/Utils";
import { GlobalVariables } from "../../../../GlobalVariables";

const AccordionEmissaoCabecalho = ({ ...props }) => {
  const {
    nfeError,
    nfeListCfop,
    headerNfe,
    setHeaderNfe,
    headerSeries,
    setHeaderSeries,
    headerIssueDate,
    setHeaderIssueDate,
    headerDemandNumber,
    setHeaderDemandNumber,
    headerAccessKey,
    setHeaderAccessKey,
    headerTypeNfe,
    headerCfop,
    setHeaderCfop,
    headerOperationNature,
    setHeaderOperationNature,
    headerPresentOperation,
    setHeaderPresentOperation,
    headerFinalCostumer,
    setHeaderFinalCostumer,
    headerOperation,
    setHeaderOperation,
    headerFinnally,
    setHeaderFinnally,
    headerIeTax,
    setHeaderIeTax,
    headerPurchaseOrder,
    setHeaderPurchaseOrder,
    headerPurchaseContract,
    setHeaderPurchaseContract,
    nfeListTypeNf,
    nfeListOperations,
    nfeListPresentOperations,
    nfeListFinnally,
    nfeListYesOrNo,
    nfeListReasonIntermed,
    headerIndicatorIntermed,
    setHeaderIndicatorIntermed,
    headerIdentifierIntermed,
    setHeaderIdentifierIntermed,
    headerIntermedCnpj,
    setHeaderIntermedCnpj,
    nfeListIntermed,
    headerReasonIntermed,
    setHeaderReasonIntermed,
    senderId,
    visualizationOnly,
    setVisualizationOnly,
    setSaveBlocked,
    nfeMontageType,
    nfeMontageSubtype,
    headerPurchasePublic,
    setHeaderPurchasePublic,
    setSelectedHeaderSeries,
    selectedHeaderSeries,
    headerSeriesOptions,
    nfeId,
    listModels,
    headerModel,
    setHeaderModel,
  } = useContext(EmissaoContext);

  const conditionForDisplayIntermedParameters = [
    GlobalVariables.nfe.inPersonOperationsTypes.notInPersonOnCallCenter,
    GlobalVariables.nfe.inPersonOperationsTypes.notInPersonOnInternet,
    GlobalVariables.nfe.inPersonOperationsTypes.notInPersonOthers,
  ];

  const { handleCfop, handleTypeNfe, handleFinallyNfe } =
    useEmissaoController();

  useEffect(() => {
    handleCfop({
      target: { value: headerCfop },
    });
    // eslint-disable-next-line
  }, [headerCfop, nfeListCfop]);

  useEffect(() => {
    if (headerReasonIntermed) {
      if (headerReasonIntermed?.identificador_usuario)
        setHeaderIdentifierIntermed(headerReasonIntermed.identificador_usuario);

      if (headerReasonIntermed?.cnpj)
        setHeaderIntermedCnpj(headerReasonIntermed.cnpj);
    }
  }, [
    headerReasonIntermed,
    setHeaderIdentifierIntermed,
    setHeaderIntermedCnpj,
  ]);

  useEffect(() => {
    if (!senderId) {
      setHeaderFinalCostumer({
        label: "SIM",
        value: "S",
      });
    }
  }, [senderId, setHeaderFinalCostumer]);

  useEffect(() => {
    setSaveBlocked(
      headerOperation?.value === GlobalVariables.nfe.operations.foreign &&
        headerTypeNfe?.value === GlobalVariables.nfe.types.entry
    );
    setVisualizationOnly(
      headerOperation?.value === GlobalVariables.nfe.operations.foreign &&
        headerTypeNfe?.value === GlobalVariables.nfe.types.entry
    );
  }, [headerOperation, headerTypeNfe, setSaveBlocked, setVisualizationOnly]);

  return (
    <Fieldset
      titulo={
        <Header>
          <Grid container spacing={2}>
            <Grid
              item
              lg={2}
              sm={3}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
            >
              <Select
                optionsList={listModels}
                value={headerModel}
                label="Modelo"
                size="small"
                descriptionField="label"
                onChange={(value) => {
                  if (value) {
                    setHeaderModel(value);
                    setSelectedHeaderSeries(null);

                    let defaultSerie = (headerSeriesOptions || []).find(
                      (serie) => serie?.default && serie?.model === value?.value
                    );

                    setSelectedHeaderSeries(defaultSerie || null);
                    setHeaderSeries(
                      defaultSerie ? defaultSerie.serieNumber : ""
                    );
                  }
                }}
                error={!!nfeError?.headerModel}
                helperText={nfeError?.headerModel || ""}
                disabled={!!nfeId}
              />
            </Grid>

            <Grid item lg={1} sm={2}>
              <TextField
                label="NFe"
                variant="filled"
                size="small"
                value={headerNfe}
                setValue={setHeaderNfe}
                disabled
              />
            </Grid>
            <Grid
              item
              container
              spacing={2}
              lg={3}
              sm={4}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
            >
              {!nfeId && (
                <Grid item xs={7}>
                  <Select
                    label="Série"
                    getOptionSelected={() => true}
                    getOptionLabel={(option) =>
                      `${option.serieNumber || "-"} - ${
                        option.description || "-"
                      }`
                    }
                    optionsList={(headerSeriesOptions || []).filter(
                      (option) => option.model === headerModel?.value
                    )}
                    descriptionField="description"
                    value={selectedHeaderSeries}
                    onChange={(newValue) => {
                      setHeaderSeries(newValue?.serieNumber || "");
                      setSelectedHeaderSeries(newValue || null);
                    }}
                  />
                </Grid>
              )}

              <Grid item xs>
                <TextField
                  label="N° Série"
                  variant="filled"
                  size="small"
                  value={headerSeries}
                  setValue={setHeaderSeries}
                  error={!!nfeError?.headerSeries}
                  disabled
                />
              </Grid>
            </Grid>
            <Grid item lg={2} sm={3}>
              <TextField
                label="Dt Emissão"
                variant="filled"
                type="date"
                size="small"
                value={headerIssueDate}
                setValue={setHeaderIssueDate}
              />
            </Grid>
            {/* <Grid item lg={2} sm={3}>
              <TextField
                label="Nro Pedido"
                variant="filled"
                size="small"
                value={headerDemandNumber}
                setValue={setHeaderDemandNumber}
                disabled
              />
            </Grid> */}
            <Grid item lg={4} sm={12}>
              <TextField
                label="Chave de Acesso"
                variant="filled"
                size="small"
                value={headerAccessKey}
                setValue={setHeaderAccessKey}
                disabled
              />
            </Grid>
          </Grid>
        </Header>
      }
      bgcolor="white"
      textcolor="black"
      accordion
    >
      <Container maxWidth="xl">
        <Body>
          <Card line="left" lineColor="primary">
            <Grid container spacing={2}>
              <Grid item lg={2} sm={2}>
                <Select
                  value={headerTypeNfe}
                  optionsList={nfeListTypeNf}
                  onChange={handleTypeNfe}
                  descriptionField="label"
                  label="Tipo"
                  error={nfeError.headerTypeNfe ? true : false}
                  helperText={nfeError.headerTypeNfe || ""}
                  disabled={visualizationOnly}
                />
              </Grid>
              <Grid item lg={2} sm={2}>
                <TextField
                  value={headerCfop}
                  label="CFOP"
                  size="small"
                  setValue={setHeaderCfop}
                  error={nfeError.headerCfop ? true : false}
                  helperText={nfeError.headerCfop || ""}
                  disabled={visualizationOnly}
                />
              </Grid>
              <Grid item lg={4} sm={8}>
                <TextField
                  value={headerOperationNature}
                  label="Natureza da Operação"
                  size="small"
                  error={nfeError.headerOperationNature ? true : false}
                  helperText={nfeError.headerOperationNature || ""}
                  setValue={setHeaderOperationNature}
                  disabled={visualizationOnly}
                />
              </Grid>
              <Grid item lg={4} sm={4}>
                <Select
                  value={headerPresentOperation}
                  setValue={setHeaderPresentOperation}
                  optionsList={nfeListPresentOperations}
                  descriptionField="label"
                  label="Operação Presencial?"
                  error={nfeError.headerPresentOperation ? true : false}
                  helperText={nfeError.headerPresentOperation || ""}
                  disabled={visualizationOnly}
                />
              </Grid>

              <Grid item lg={2} sm={2}>
                <Select
                  value={headerFinalCostumer}
                  optionsList={nfeListYesOrNo}
                  descriptionField="label"
                  setValue={setHeaderFinalCostumer}
                  label="Consumidor Final"
                  error={nfeError.headerFinalCostumer ? true : false}
                  helperText={nfeError.headerFinalCostumer || ""}
                  disabled={visualizationOnly}
                />
              </Grid>
              <Grid item lg={6} sm={3}>
                <Select
                  optionsList={nfeListOperations}
                  value={headerOperation}
                  label="Operação"
                  size="small"
                  descriptionField="label"
                  setValue={setHeaderOperation}
                  error={nfeError.headerOperation ? true : false}
                  helperText={nfeError.headerOperation || ""}
                  disabled={
                    (nfeMontageType === "A" && nfeMontageSubtype === "DI") ||
                    nfeMontageSubtype === "DI"
                  }
                />
              </Grid>
              <Grid item lg={4} sm={3}>
                <Select
                  value={headerFinnally}
                  optionsList={nfeListFinnally}
                  descriptionField="label"
                  label="Finalidade"
                  setValue={setHeaderFinnally}
                  onChange={(newValue) => {
                    setHeaderFinnally(newValue);
                    handleFinallyNfe(newValue);
                  }}
                  error={nfeError.headerFinnally ? true : false}
                  helperText={nfeError.headerFinnally || ""}
                  disabled={visualizationOnly}
                />
              </Grid>
              <Grid item lg={6} sm={6}>
                <TextField
                  label="IE Substituto Tributário"
                  size="small"
                  value={headerIeTax}
                  setValue={setHeaderIeTax}
                  disabled={visualizationOnly}
                />
              </Grid>
              <Grid item lg={2} sm={2}>
                <TextField
                  value={headerPurchasePublic}
                  setValue={setHeaderPurchasePublic}
                  label="Nota Empenho(Compras públicas)"
                  size="small"
                  disabled={visualizationOnly}
                />
              </Grid>
              <Grid item lg={2} sm={2}>
                <TextField
                  value={headerPurchaseOrder}
                  setValue={setHeaderPurchaseOrder}
                  label="Pedido Compra"
                  size="small"
                  disabled={visualizationOnly}
                />
              </Grid>
              <Grid item lg={2} sm={2}>
                <TextField
                  value={headerPurchaseContract}
                  setValue={setHeaderPurchaseContract}
                  label="Contrato Compra"
                  size="small"
                  disabled={visualizationOnly}
                />
              </Grid>
            </Grid>
          </Card>
          {conditionForDisplayIntermedParameters.includes(
            headerPresentOperation?.value
          ) && (
            <Grow
              in={conditionForDisplayIntermedParameters.includes(
                headerPresentOperation?.value
              )}
            >
              <Margin top="15">
                <Card
                  line="left"
                  lineColor="primary"
                  label="Parâmetros de Intermediador"
                >
                  <Grid container spacing={2}>
                    <Grid item sm={4}>
                      <Select
                        variant="filled"
                        value={headerIndicatorIntermed}
                        optionsList={nfeListIntermed}
                        descriptionField="label"
                        label="Indicador de Intermediador/Marketplace"
                        setValue={setHeaderIndicatorIntermed}
                        error={nfeError.headerIndicatorIntermed ? true : false}
                        helperText={nfeError.headerIndicatorIntermed || ""}
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grow in={headerIndicatorIntermed?.value === "1"}>
                      <Grid item sm={8}>
                        <Select
                          value={headerReasonIntermed}
                          optionsList={nfeListReasonIntermed}
                          descriptionField="razao"
                          label="Razão social"
                          setValue={setHeaderReasonIntermed}
                          error={nfeError.headerReasonIntermed ? true : false}
                          helperText={nfeError.headerReasonIntermed || ""}
                          disabled={visualizationOnly}
                        />
                      </Grid>
                    </Grow>
                    <Grow in={headerIndicatorIntermed?.value === "1"}>
                      <Grid item sm={6}>
                        <TextField
                          value={headerIdentifierIntermed}
                          setValue={setHeaderIdentifierIntermed}
                          label="Identificador cadastrado no Intermediador"
                          size="small"
                          error={
                            nfeError.headerIdentifierIntermed ? true : false
                          }
                          helperText={nfeError.headerIdentifierIntermed || ""}
                          disabled={visualizationOnly}
                        />
                      </Grid>
                    </Grow>
                    <Grow in={headerIndicatorIntermed?.value === "1"}>
                      <Grid item sm={6}>
                        <TextField
                          value={headerIntermedCnpj}
                          setValue={setHeaderIntermedCnpj}
                          label="CNPJ do Intermediador"
                          size="small"
                          error={nfeError.headerIntermedCnpj ? true : false}
                          helperText={nfeError.headerIntermedCnpj || ""}
                          disabled={visualizationOnly}
                        />
                      </Grid>
                    </Grow>
                  </Grid>
                </Card>
              </Margin>
            </Grow>
          )}
        </Body>
      </Container>
    </Fieldset>
  );
};

export default AccordionEmissaoCabecalho;
